/**
 * First-level administrative units of Kazakhstan: 17 regions plus the three
 * cities of republican significance (per stat.gov.kz, 1 Jan 2026 — includes
 * Abai, Jetisu and Ulytau, created in 2022).
 *
 * `value` is the canonical Russian name sent to the backend regardless of the
 * interface language, so owners never receive a mix of RU and KZ region names
 * in their Telegram notifications. `kz` is display-only.
 */
export const REGIONS = [
  { value: "Западно-Казахстанская область", kz: "Батыс Қазақстан облысы" },
  { value: "Абайская область", kz: "Абай облысы" },
  { value: "Акмолинская область", kz: "Ақмола облысы" },
  { value: "Актюбинская область", kz: "Ақтөбе облысы" },
  { value: "Алматинская область", kz: "Алматы облысы" },
  { value: "Атырауская область", kz: "Атырау облысы" },
  { value: "Восточно-Казахстанская область", kz: "Шығыс Қазақстан облысы" },
  { value: "Жамбылская область", kz: "Жамбыл облысы" },
  { value: "Жетысуская область", kz: "Жетісу облысы" },
  { value: "Карагандинская область", kz: "Қарағанды облысы" },
  { value: "Костанайская область", kz: "Қостанай облысы" },
  { value: "Кызылординская область", kz: "Қызылорда облысы" },
  { value: "Мангистауская область", kz: "Маңғыстау облысы" },
  { value: "Павлодарская область", kz: "Павлодар облысы" },
  { value: "Северо-Казахстанская область", kz: "Солтүстік Қазақстан облысы" },
  { value: "Туркестанская область", kz: "Түркістан облысы" },
  { value: "Улытауская область", kz: "Ұлытау облысы" },
  { value: "город Астана", kz: "Астана қаласы" },
  { value: "город Алматы", kz: "Алматы қаласы" },
  { value: "город Шымкент", kz: "Шымкент қаласы" },
];

// The company operates out of Uralsk, so its own region is the sensible default.
export const DEFAULT_REGION = "Западно-Казахстанская область";

export const regionLabel = (region, lang) => (lang === "kz" ? region.kz : region.value);
